import required from "@libs/required";
import { zipcodeValidation } from "../@data/validation";
import { action, computed, observable, toJS } from "mobx";

class Zipcode {
	@observable zipcode;

	constructor(rootStore, { app }) {
		this.rootStore = rootStore;
		this.zipcode = app.location.zipcode;
	}

	get proSignupFunnelModalStore() {
		const { proSignupFunnelModalStore } = this.rootStore.stores;
		return proSignupFunnelModalStore;
	}

	get value() {
		return (
			this.proSignupFunnelModalStore.data?.zipcode || toJS(this.zipcode) || ""
		);
	}

	@action
	update(val = required`val`) {
		try {
			zipcodeValidation.validateSync(val);
			this.zipcode = val;
		} catch (err) {
			throw err;
		}
	}
}

export default Zipcode;
